module.exports = __webpack_public_path__ + "img/茂名市工业和信息化局.18c3d706.png";